import Http from "../../http/client";
import {RequestQueryBuilder} from "@nestjsx/crud-request";

export default async (id) => {
  const qb = RequestQueryBuilder.create();

  qb.setFilter({ field: "id", operator: "$eq", value: id });
  qb.setJoin({field: 'models'});

  const response = await Http.get('admin/vehicle/manufacturers', {
    params: qb.queryObject
  });

  return response.data;
}
